import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const radio = ({ palette }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiRadio"] => ({
    root: {
        flexShrink: 0,
        flexGrow: 0,
        color: palette.grey35,
        padding: "6px"
    },
    colorPrimary: {
        "& .MuiSvgIcon-root": {
            fontSize: "2rem",
        },


        "&:hover, &.Mui-checked": {

        },
        "&:hover": {

        },

        "&.Mui-checked": {


        },
        "&.Mui-checked:hover": {


        },
        "&.Mui-disabled": {

        },
    },
});

export default radio;
